export const currencyEnum = {
  GBP: '£',
  EUR: '€',
  USD: '$'
}

// Stripe's minimum chargeable amount for GBP, in pence.
// Payment intents below this value are rejected by Stripe.
export const STRIPE_MINIMUM_CHARGE_GBP = 30

export const currencyOptions = Object.keys(currencyEnum).map(key => ({
  value: key,
  label: currencyEnum[key]
}))
